module.exports = __webpack_public_path__ + "static/media/OM.17672ba8.png";